/* eslint-disable react/jsx-max-props-per-line */
import type React from 'react';
import { useEffect, useState } from 'react';

import { useGetFaceAttributeSamples, useEstimateSdk } from '@vlabs/api/artemy/client';
import type { FaceId, OneImageEstimation, SdkResponseJson } from '@vlabs/api/artemy/model';
import { useTranslation } from 'react-i18next';

import { EmotionsValue } from './EmotionsValue';
// import { EyesValue } from './EyesValue';
import st from './FaceAdditionalAttributes.module.sass';
import { MouthValue } from './MouthValue';
import { AttributeInfoRow } from '../attribute-info-row/AttributeInfoRow';

interface FaceAdditionalAttributesProps {
  faceId: FaceId;
}

function FaceAdditionalAttributes({
  faceId,
}: FaceAdditionalAttributesProps): React.JSX.Element {
  const { t } = useTranslation();
  const [extractedAttributes, setExtractedAttributes] = useState<SdkResponseJson>();
  const getFaceSamples = useGetFaceAttributeSamples(faceId);
  const { mutate: requestSDK } = useEstimateSdk({
    mutation: {
      onSuccess: setExtractedAttributes,
      onError: () => setExtractedAttributes(undefined),
    },
  });
  const faceAttributes = (extractedAttributes?.images_estimations?.[0] as OneImageEstimation)
    ?.estimations?.[0]?.face?.detection.attributes;
  const qualityAttributes = (extractedAttributes?.images_estimations?.[0] as OneImageEstimation)
    ?.estimations?.[0]?.face?.detection.quality;

  useEffect(() => {
    if (!getFaceSamples.data?.samples) return;

    requestSDK({
      data: { samples: getFaceSamples.data.samples },
      params: {
        image_type: 1,
        estimate_quality: 1,
        estimate_mouth_attributes: 1,
        estimate_emotions: 1,
        estimate_glasses: 1,
        // не работает на варпах
        // estimate_eyes_attributes: 1,
        // estimate_head_pose: 1
        // estimate_gaze: 1,
      },
    });
  }, [getFaceSamples.data?.samples, requestSDK]);

  return (
    <div className={st.Root}>
      <AttributeInfoRow title={t('засвеченность')} value={qualityAttributes?.light} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('затемненность')} value={qualityAttributes?.dark} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('размытость')} value={qualityAttributes?.blurriness} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('наличие бликов')} value={qualityAttributes?.specularity} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('равномерность освещения')} value={qualityAttributes?.illumination} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('статус рта')} value={<MouthValue mouthAttributes={faceAttributes?.mouth_attributes} />} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('emotion')} value={<EmotionsValue emotions={faceAttributes?.emotions} />} />
      <span className={st.Divider} />
      <AttributeInfoRow title={t('glasses')} value={t(`glasses_states.${faceAttributes?.glasses?.glasses}`)} />
      {/*
      // не работает на варпах
      <span className={st.Divider} />
      <InfoRow title={t('направление взгляда (pitch)')} value={faceAttributes?.gaze?.pitch} />
      <span className={st.Divider} />
      <InfoRow title={t('направление взгляда (yaw)')} value={faceAttributes?.gaze?.yaw} />
      <span className={st.Divider} />
      <InfoRow title={t('статус глаз')} value={<EyesAttributes eyesAttributes={faceAttributes?.eyes_attributes} />} />
      */}
    </div>
  );
}

export { FaceAdditionalAttributes };
